const initialState = () => ({
  dealIds: [],
  interval: null,
});

export { initialState as state };

export const mutations = {
  add(state, dealId) {
    let { dealIds } = state;

    if (!Array.isArray(dealIds)) {
      dealIds = [];
    }
    dealIds.push(dealId);

    state.dealIds = dealIds; // eslint-disable-line no-param-reassign
  },
  interval(state, data) {
    state.interval = data + 0; // eslint-disable-line no-param-reassign
  },
  reset(state) {
    clearInterval(state.interval);
    state.dealIds = []; // eslint-disable-line no-param-reassign
    state.interval = null; // eslint-disable-line no-param-reassign
  },
};

export const actions = {};
